export default "__VITE_ASSET__BZrfN9rY__"